import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './Pill.module.scss'

const propTypes = {
  /**
   * content of the pill
   */
  children: PropTypes.node.isRequired,
  /**
   * "inactive" style of the pill
   */
  textGray: PropTypes.bool,
  /**
   * Classname to override default styles
   */
  className: PropTypes.string,
}

const defaultProps = {
  textGray: false,
  className: '',
}

function Pill(props) {
  const { children, textGray, className } = props
  return <div className={clsx('mr-2 mb-2', styles.pill, textGray && styles.textGray, className)}>{children}</div>
}

Pill.propTypes = propTypes
Pill.defaultProps = defaultProps

export default Pill
